import React, { useState } from "react"

const SearchBox = ({
  placeholderText,
  searchclassnamewrapper,
  value,
  onChange,
}) => {
  const [inputValue, setInputValue] = useState(value)

  const handleChange = (event) => {
    const newValue = event.target.value
    setInputValue(newValue)
    if (onChange) {
      onChange(event)
    }
  }

  const handleClear = () => {
    setInputValue("")
    if (onChange) {
      onChange({ target: { value: "" } })
    }
  }

  return (
    <div className={searchclassnamewrapper || "searchbox_wrapper"}>
      <div className="search_form d-flex gap-2">
        <div className="input-group">
          <div className="input-group-text">
            <i className="icon_main search_icon"></i>
          </div>
          <input
            type="text"
            className="form-control"
            name="search"
            id="search"
            onChange={handleChange}
            value={inputValue}
            placeholder={placeholderText || "Search here..."}
          />
          {inputValue && (
            <button
              className="search_canclebtn"
              aria-label="Clear search"
              onClick={handleClear}
            >
              <i className="icon_main cross_icon"></i>
            </button>
          )}
        </div>
      </div>
    </div>
  )
}

export default SearchBox
